import { DropDownStatus } from '@reveni-io/reveni-ui'

const SelectBadgeStatus = ({ statusOptions, selected, onChange, fullWidth, height }) => {
  const handleClick = event => {
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <div onClick={handleClick}>
      <DropDownStatus
        items={statusOptions}
        selected={selected}
        onChange={onChange}
        fullWidth={fullWidth}
        height={height}
      />
    </div>
  )
}

export default SelectBadgeStatus
